import httpClient from '../httpClient';

const projectPositions = {
  annoucementSelector: 'et_announcement_selector',
};

const projectSelector = async () => {
  return await httpClient.get('/et_project_selector');
};

const post = async (data) => {
  return await httpClient.post(`/project_positions/`, data);
};

const getRoleByProject = async (project_id) => {
  return await httpClient.get(
    `/project_positions/?filter[proyecto]=${project_id}&page[size]=1000`,
  );
};

const get = async (id) => {
  return await httpClient.get(`/project_positions/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/project_positions/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/project_positions/${id}`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/project_positions/export` + `${query}&sort=${sortBy}` + `${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/project_positions` +
        `${query}&page[number]=${page}&page[size]=${pageSize}` +
        `&sort=${sortBy}` +
        `${searchBy}`,
    );
};

const announcementRoles = async (query) => {
  return await httpClient.get(
    `project_positions/announcement_roles/?filter[convocatoria]=${query}`,
  );
};

export {
  projectSelector,
  post,
  getRoleByProject,
  get,
  put,
  remove,
  ajaxTable,
  announcementRoles,
  projectPositions,
};
